<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Koran Libur / Tidak Terbit
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col md="4">
            <b-input-group >
                <b-input-group-prepend><span class="p-2">Bulan</span></b-input-group-prepend>
                <b-form-select v-model="tblData.month" :plain="true" :options="monthLabels" style="width:25% !important;"></b-form-select>
                <b-input-group-prepend><span class="p-2">Tahun</span></b-input-group-prepend>
                <b-form-input v-model="tblData.year" type="number"></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="5">
            <b-input-group >
                <b-input-group-prepend><span class="p-2">Keterangan</span></b-input-group-prepend>
                <b-form-input v-model="tblData.description" ></b-form-input>
                <b-input-group-append>
                      <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                </b-input-group-append>
                <b-input-group-append>
                      <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(index)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>

        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row >
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
            <b-input-group >
                <b-input-group-prepend><span  class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card >
          <div slot="header">Form - Koran Libur / Tidak Terbit
          </div>
                <b-input-group >
                    <b-input-group-prepend><label>Tanggal</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.date" :state="!$v.frmdata.date.$error" type="date"></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.description" :state="!$v.frmdata.description.$error" ></b-form-input>
                </b-input-group>
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
              <b-button class="btn btn-danger mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>

        </b-card>
        </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 160px;
            }
        }
    }
</style>


<script>
import toastr from "mini-toastr";
import koranlibur from "../../apis/koranlibur";
import moment from 'moment'
import myNumber from "../../components/my-number";
import dropdown from "../../data/dropdown";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        date: { required },
        description: { required }
    },
  }, 
  components:{myNumber},
  data() {
    return {
      showDelConfirm: false,
      showList:true,
      showForm:false,
      uanguser: this.$store.state.user.matauang,
      frmdata:{date: '',description:'' },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'date',
        sortDesc: false
      },
      monthLabels:dropdown.monthLabels
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "index",
            label: "No.",
            thStyle: "width:60px",
          },
          {
            key: "date",
            label: "Tanggal",
            sortable: true,
            formatter: 'dateformatter'
          },
          {
            key: "description",
            label: "Description",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          } 
         ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: function(){
      this.monthLabels = dropdown.monthLabels.reduce((newArr,item, bln) =>{
            newArr.push({ value: bln+1, text: item});
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);

  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await koranlibur.list(this.tblData);      
      return list;
    },
    search() {
      this.tblData.page=1;
      this.refresh();
    },     
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.year= '';
        this.tblData.month= '';
        this.tblData.description= '';
        this.refresh();
    },    
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
            if(key=='date') 
              this.frmdata[key] = moment(new Date(this.model[key])).format('YYYY-MM-DD');
        }
      this.frmdata.idlama = data.id;

      console.log('this.frmdata', this.frmdata);
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
      const user = this.$store.state.user.username;
      const compcode = this.$store.state.user.compcode;
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              this.frmdata.year= moment(this.frmdata.date).format('YYYY');
              this.frmdata.month= moment(this.frmdata.date).format('MM');
              this.frmdata.date= moment(this.frmdata.date).format('YYYY-MM-DD');
              await koranlibur.save(this.frmdata);
              toastr.success(`Success`, "Save Libur",10000);
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await koranlibur.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push({name: "iklankoran.home"});
    },  
    dateformatter: function (value, key, item) {
      // console.log(value)
      return `${moment(new Date(value)).format('DD/MM/YYYY')}`
    },  
  }
};
</script>
